<template>
  <div>
    <div class="crumbs">
      <a href="/download_app">美菜商城</a> > 帮助中心
    </div>
    <div class="help-all">
      <div class="help-left">
        <div class="title">常见问题</div>
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">账户问题</template>
            <ul @click="open()">
              <li class="item" data-index="account1">注册和登录美菜账户</li>
              <li class="item" data-index="account2">修改账户信息</li>
              <li class="item" data-index="account3">修改门店信息</li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="订购问题">
            <ul @click="open()">
              <li class="item" data-index="order1">如何查找想要的商品</li>
              <li class="item" data-index="order2">如何订购商品</li>
              <li class="item" data-index="order3">如何取消订单</li>
              <li class="item" data-index="order5">什么时候可以下单</li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="发票问题">
            <ul @click="open()">
              <li class="item" data-index="invoice1">如何申请发票</li>
              <li class="item" data-index="invoice2">发票开具周期</li>
              <li class="item" data-index="invoice3">发票类型及税点</li>
              <li class="item" data-index="invoice4">如何填写发票内容</li>
              <li class="item" data-index="invoice5">开发票注意事项</li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="配送问题">
            <ul @click="open()">
              <li class="item" data-index="distribution1">开通的服务城市</li>
              <li class="item" data-index="distribution2">配送时间</li>
              <li class="item" data-index="distribution3">如何查询配送信息</li>
              <li class="item" data-index="distribution4">起送金额及配送费用</li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="退货问题">
            <ul @click="open()">
              <li class="item" data-index="refund1">退货标准及周期</li>
              <li class="item" data-index="refund2">如何查询退货信息</li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="货款问题">
            <ul @click="open()">
              <li class="item" data-index="goods1">支付方式</li>
              <li class="item" data-index="goods2">如何查看优惠券</li>
              <li class="item" data-index="goods3">如何使用优惠券</li>
              <li class="item" data-index="goods4">使用优惠券的订单如何退款</li>
              <li class="item" data-index="goods5">余额充值</li>
              <li class="item" data-index="goods6">账户余额是否可以提现</li>
            </ul>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="help-right">
        <component :is="currentComponent"></component>
      </div>
      <div class="clear"></div>
    </div>
    <HomeFooter />
  </div>
</template>

<script>
import HomeFooter from "../home/components/footer";
import account1 from "./components/account1";
import account2 from "./components/account2";
import account3 from "./components/account3";
import distribution1 from "./components/distribution1";
import distribution2 from "./components/distribution2";
import distribution3 from "./components/distribution3";
import distribution4 from "./components/distribution4";
import order1 from "./components/order1";
import order2 from "./components/order2";
import order3 from "./components/order3";
import order4 from "./components/order4";
import order5 from "./components/order5";
import goods1 from "./components/goods1";
import goods2 from "./components/goods2";
import goods3 from "./components/goods3";
import goods4 from "./components/goods4";
import goods5 from "./components/goods5";
import goods6 from "./components/goods6";
import invoice1 from "./components/invoice1";
import invoice2 from "./components/invoice2";
import invoice3 from "./components/invoice3";
import invoice4 from "./components/invoice4";
import invoice5 from "./components/invoice5";
import refund1 from "./components/refund1";
import refund2 from "./components/refund2";
export default {
  name: "partner",
  components: {
    HomeFooter,
    account1,
    account2,
    account3,
    order1,
    order2,
    order3,
    order4,
    order5,
    distribution1,
    distribution2,
    distribution3,
    distribution4,
    goods1,
    goods2,
    goods3,
    goods4,
    goods5,
    goods6,
    invoice1,
    invoice2,
    invoice3,
    invoice4,
    invoice5,
    refund1,
    refund2
  },
  data() {
    return {
      currentComponent: "account1"
    };
  },
  methods: {
    open() {
      console.log(event.target.dataset.index)
      this.currentComponent = event.target.dataset.index
    }
  }
};
</script>

<style lang="scss">
.crumbs {
  width: 1000px;
  margin: 0 auto;
  padding: 20px 0;
  color: #757575;
  font-size: 14px;
  a {
    color: #757575;
    &:hover {
      color: #63ac48;
    }
  }
}
.help-all {
  width: 1000px;
  margin: 0 auto;
  padding-bottom: 105px;
}
.help-left {
  width: 200px;
  float: left;
  .title {
    background: #4acb81;
    color: #fff;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    margin-bottom: 5px;
  }
}
.help-right {
  width: 780px;
  float: right;
  border: 1px solid #d8d8d8;
  min-height: 550px;
  .title {
    height: 40px;
    background: #f2f2f2;
    line-height: 40px;
    font-size: 18px;
    padding-left: 12px;
    color: #322f2e;
  }
  .content-info {
    padding: 15px;
  }
  .txt1 {
    color: #565656;
    padding: 5px 0;
    line-height: 2;
  }
  ul {
    font-size: 0;
    li {
      display: inline-block;
      padding: 20px 40px;
    }
  }
}
</style>
<style lang="scss">
.el-collapse {
  border: 1px solid #f3f3f3;
  border-bottom: none;
}
.el-collapse-item__header {
  background: #f2f2f2;
  padding-left: 20px;
  height: 41px;
  font-size: 14px;
  border-bottom: 1px solid #e5e5e5;
  cursor: pointer;
  .el-collapse-item__arrow {
    transform: rotate(90deg);
  }
}
.el-collapse-item__content {
  padding-bottom: 0px;
  ul {
    li {
      font-size: 14px;
      padding-left: 20px;
      height: 42px;
      line-height: 42px;
      border-bottom: 1px solid rgb(229, 229, 229);
      color: rgb(56, 56, 56);
      cursor: pointer;
    }
  }
}
</style>
